import { ConfirmModal } from "@/components";
import React, { useState } from "react";
import { useDeleteNotification } from "../hooks";

type ActionDeleteProps = {
  id: number;
};

const ActionDelete: React.FC<ActionDeleteProps> = ({ id }) => {
  const [open, setOpen] = useState(false);
  const { deleteNoti, isPending } = useDeleteNotification(id);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <div>
      <button
        className="text-nowrap text-error_main p-2 px-4"
        onClick={openModal}
      >
        削除
      </button>

      <ConfirmModal
        open={open}
        onOpenChange={setOpen}
        onConfirm={() => deleteNoti().then(closeModal)}
        isPending={isPending}
        type="delete"
      />
    </div>
  );
};

export default ActionDelete;
